import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { ApiContainer } from "../utils/api";
import {
  ON_FLAG_CHANGE,
  ON_FORM_CHANGE,
  SET_API_DATA,
  SET_USER_DATA,
} from "../redux/constants";
import { getSlug } from "../shared/CustomFunc";

const waiversContainer = () => {
  const { api } = ApiContainer();
  const history = useNavigate();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [downloadLoading, setDownloadLoading] = useState({});
  const modelState = useSelector((state) => state?.modelStates);
  const waiversResult = useSelector((state) => state.api.waiversResult);
  const isWaiverSigned = useSelector((state) => state.api.isWaiverSigned);
  const userRoleData = useSelector((state) => state.app?.userData);

  const refetchWaivers = useSelector(
    (state) => state.app.flags?.refetchWaivers
  );
  const waiversLoader = useSelector(
    (state) => state.api?.loader?.waiversResult
  );
  const { assessmentListForTakeAssessment: assessmentList } = useSelector(
    (state) => state.api
  );
  const remainingAssessment = assessmentList?.length
    ? assessmentList.find(
        (assessment) =>
          assessment.is_required_for_signup && !assessment.assessment_taken
      )
    : null;

  const getReport = async () => {
    const response = await api({
      method: "GET",
      endPoint: "waiver/list",
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "waiversResult",
    });

    if (response?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          waiversResult: response?.data?.waiver,
          isWaiverSigned: response?.data?.is_waiver_signed,
        },
      });
    }
  };

  const handleDocumentDownload = async (data) => {
    const waiverId = data?.waiver_id;
    setDownloadLoading((prev) => ({ ...prev, [waiverId]: true }));

    if (data?.path) {
      const fileName = "document.pdf";
      const link = document.createElement("a");
      link.href = data?.path;
      link.download = fileName;
      link.click();
      setDownloadLoading((prev) => ({ ...prev, [waiverId]: false }));
    }
  };
  const handleWaiversClick = async (data) => {
    navigate(`/edit-profile/waivers-form/${data}`);
  };

  useEffect(() => {
    if (refetchWaivers) {
      getReport();
      dispatch({
        type: ON_FLAG_CHANGE,
        payload: { refetchWaivers: false },
      });
    }
  }, [refetchWaivers]);

  useEffect(() => {
    getReport();
  }, []);

  useEffect(() => {
    if (isWaiverSigned) {
      dispatch({
        type: SET_USER_DATA,
        payload: {
          ...userRoleData,
          user_profile: {
            ...userRoleData?.user_profile,
            is_waiver_signed: true,
          },
        },
      });
    }
  }, [isWaiverSigned]);

  useEffect(() => {
    if (
      isWaiverSigned &&
      remainingAssessment &&
      !["/get-started", "/quick-note"].some((path) =>
        pathname?.includes(path)
      ) &&
      !(pathname?.includes("assessment") && !pathname?.includes("/assessments"))
    ) {
      localStorage.setItem(
        "currentAssessmentId",
        remainingAssessment?.assessment_id
      );
      const slug = getSlug(assessmentList, remainingAssessment?.assessment_id);
      history(`/get-started/${slug}`);
    }
  }, [isWaiverSigned]);

  return {
    waiversResult,
    waiversLoader,
    modelState,
    handleDocumentDownload,
    downloadLoading,
    isWaiverSigned,
    dispatch,
    handleWaiversClick,
  };
};

export default waiversContainer;
